import Vue from "vue";
import Axios from "axios";
import AppConfig from "@DigitalCatalogue/Scripts/Config/AppConfig";
import { router } from "@DigitalCatalogue/Scripts/Config/RouteConfig";
import { store } from "@DigitalCatalogue/Scripts/Config/StoreConfig";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "DigitalCatalogue", "Contact", "Account", "CookieToast"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                this.$store.dispatch("favoriteStore/getFavorites");

                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setNavigation();
        this.openInfoRequest();
        this.showSearch();
        this.setAnalytics();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setNavigation() {
        let app = document.getElementById("body"),
            scrim = document.getElementById("scrim"),
            btnmenu = document.getElementById("btnmenu"),
            header = document.getElementById("header")

        if (btnmenu) {
            btnmenu.addEventListener("click", function () {
                app.classList.toggle("menu-show");
            });
        }

        if (header) {
            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-minify", "");
                    header.setAttribute("data-hide", "");
                } else {
                    header.removeAttribute("data-minify");
                    header.removeAttribute("data-hide");
                }
            });

            let posizioneScroll = window.pageYOffset;

            window.addEventListener("scroll", function () {
                if (window.pageYOffset < posizioneScroll) {
                    header.removeAttribute("data-hide");
                }
                posizioneScroll = window.pageYOffset;
            });
        }
    }

    private static openInfoRequest() {
        let buttons = document.querySelectorAll(".is-info-request");
        for (const item of buttons) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("infoRequestStore/setInfoRequestVisible", true);
            })
        }
    }

    private static showSearch() {
        let header = document.getElementById("header"),
            btnsearch = document.getElementById("btnsearch")

        if (btnsearch) {
            btnsearch.addEventListener("click", function () {
                header.classList.toggle("show-search");
            });
        }
    }

    public static setRandomimage() {
        function getRandomImage(): string {
            const images = ["image01.jpg", "image02.jpg", "image03.jpg"];
            const randomIndex = Math.floor(Math.random() * images.length);
            const randomImage = images[randomIndex];
            return "/areas/digitalcatalogue/images/404/" + randomImage;
        }
        
        function setBackground(wrapper: string): void {
            const container = document.getElementById(wrapper);
            if (container) {
                const randomImage = getRandomImage();
                container.style.backgroundImage = "url(" + randomImage + ")";
            }
        }
        
        setBackground("Visual404");
    }

    public static setAnalytics() {
        let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
        for (const item of dataGaeventLinkTrue) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendEvent(
                        this.getAttribute("data-ganame") ? this.getAttribute("data-ganame") : "click",
                        this.getAttribute("data-gacategory"),
                        this.getAttribute("data-galabel") === "link" ? this.getAttribute("href") : this.getAttribute("data-galabel"),
                    );
                });
            }
        }
    }
}